import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import RaceMeetingControllerImpl from './race-meeting-controller.js';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * Module that displays a race meeting (or several race meetings combined due to starting time happens on same date
 * for a track).
 *
 * @class RaceMeetingController
 * @name RaceMeeting
 * @memberof Mojito.Modules
 */

/**
 * RaceMeetingController prop types.
 *
 * @property {string} sportId - ID of the sport.
 * @property {string} meetingId - ID of the meeting. If the ID includes any '-', it consists of more than one meeting grouped together.
 * @property {string} [raceId] - ID of a race event in the meeting.
 * @property {Array} [meetings] - Associative array containing all meetings.
 *
 * @memberof Mojito.Modules.RaceMeeting
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    meetingId: PropTypes.string.isRequired,
    raceId: PropTypes.string,
    meetings: PropTypes.array,
};

export default UIControllerView('RaceMeetingController', RaceMeetingControllerImpl, propTypes);
